export enum TableTheme {
  default = "default", // Light unless inside a dark theme
  light = "light",
  dark = "dark",
}

export type TableThemes = keyof typeof TableTheme;

export type TableProps = {
  children?: React.ReactNode;
  headers: { value: string; isHidden?: boolean }[];
  rows: TableCellValue[][];
  theme?: TableThemes;
  hasHeaderDivide?: boolean;
  className?: string;
};

export type TableHeaderProps = {
  key?: string;
  value: string;
  isHidden?: boolean;
  className?: string;
};

export type TableCellProps = {
  className?: string;
  value: TableCellValue;
};

export type TableCellValue = {
  key: string;
  value: string | React.ReactElement;
  highlightValue?: boolean;
  link?: string;
  tooltipCopy?: string;
};
